<template>

  <div class="tabs-item">

    <slot></slot>

  </div>

</template>

<script>
  export default {
    name: 'TabsItem',

    props: {
      name: String,
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/TabsItem.vue